import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import { withTheme } from 'react-jss'
import compose from '@shopify/react-compose'

import InputError from 'components/form/input-error'

import styles from 'components/form/form-style'

const CheckboxInput = props => {
  const classes = styles(props.theme)

  // fixes validateOnBlur option not triggering blur
  const change = (input, e) => {
    input.onChange(e)
    input.onBlur(e)
    props.onChange(e.target.checked)
  }

  return (
    <Field name={props.name} type="checkbox" value={props.value}>
      {({ input, meta }) => (
        <div className={classes.block}>
          <label className={classes.checkboxText}>
            <input {...input} onChange={e => change(input, e)} type="checkbox" className={classes.checkboxInput} disabled={props.disabled} />
            {props.labelHtml
              ? <span dangerouslySetInnerHTML={{ __html: props.labelHtml }} />
              : props.label
            }
          </label>
          <InputError meta={meta} direction="left" className={classes.errorCheckbox} />
          {props.children}
        </div>
      )}
    </Field>
  )
}

CheckboxInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelHtml: PropTypes.string,
  theme: PropTypes.object.isRequired,
  value: PropTypes.any,
  children: PropTypes.node,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}

CheckboxInput.defaultProps = {
  onChange: () => {},
  disabled: false,
}

export default compose(
  withTheme
)(CheckboxInput)
